import { memo } from "react"

import { BackButton } from "../../components/Buttons/BackButton"
import { BaseTopBar } from "../TopBars/BaseTopBar"

export const EditFormSubmissionViewTopBar = memo(() => {
	return <BaseTopBar leftContent={<BackButton />} />
})
EditFormSubmissionViewTopBar.displayName = "EditFormSubmissionViewTopBar"
